// Content copy for copypro3d.it landing page (Italian)
export const LOGO_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_b65ec71a-b86f-453a-8a9c-6090cf6c59e6/artifacts/rng9hjf0_Logo%20Copypro3d.it%2C%20Nuovo.png";

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1642969164999-979483e21601?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxtYWNybyUyMDNkJTIwcHJpbnRlciUyMHByaW50aW5nfGVufDB8fHx8MTc4NDkxNjczMHww&ixlib=rb-4.1.0&q=85";

export const PROBLEMS = [
  "Sei stanco di rinunciare a un'idea perché produrla in modo tradizionale costa troppo o richiede troppo tempo?",
  "Sei stanco di trovare solo prodotti standard, che non rispettano misure, forme o dettagli che ti servono davvero?",
  "Sei stanco di perdere ore tra preventivi confusi, fornitori lenti e risposte poco chiare?",
  "Sai già come una semplice modifica al progetto potrebbe migliorare il risultato, ma non hai un partner che la realizzi velocemente?",
  "Sai già come ti serve un servizio affidabile, preciso e capace di gestire anche richieste personalizzate senza complicazioni?",
];

export const BENEFITS = [
  { t: "Tempi ridotti", d: "Riduci le attese rispetto alle soluzioni tradizionali." },
  { t: "Zero sprechi", d: "Eviti investimenti inutili in stampi o produzioni minime troppo alte." },
  { t: "Pezzi su misura", d: "Ottieni oggetti coerenti con il tuo bisogno reale." },
  { t: "Testa prima", d: "Puoi validare un'idea prima di produrre in grande." },
  { t: "Massima libertà", d: "Più libertà nella personalizzazione del progetto." },
  { t: "Supporto reale", d: "Supporto concreto nella valutazione del file e della stampa." },
  { t: "Qualità percepita", d: "Aumenti il valore del tuo prodotto o della tua iniziativa." },
];

export const PROCESS = [
  { n: "01", t: "Invia il file", d: "Carica il tuo STL o descrivi il progetto. Valuto fattibilità e criticità prima di partire." },
  { n: "02", t: "Stampa FDM/PLA", d: "Stampo con cura, materiali di qualità e attenzione al risultato finale." },
  { n: "03", t: "Finitura & consegna", d: "Post-processing su richiesta, controllo qualità e consegna pronta all'uso." },
];

export const GALLERY = [
  {
    url: "https://images.pexels.com/photos/9242916/pexels-photo-9242916.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    t: "Ingranaggi meccanici",
    tag: "Prototipo funzionale",
  },
  {
    url: "https://images.unsplash.com/photo-1675415486004-56bae3e1fd25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHwzZCUyMHByaW50ZWQlMjBhcmNoaXRlY3R1cmFsJTIwbW9kZWx8ZW58MHx8fHwxNzg0OTE2NzMwfDA&ixlib=rb-4.1.0&q=85",
    t: "Modello architettonico",
    tag: "Plastico in scala",
  },
  {
    url: "https://images.pexels.com/photos/29148783/pexels-photo-29148783.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    t: "Modello abitativo",
    tag: "Piccolo lotto",
  },
];

export const TESTIMONIALS = [
  {
    q: "Avevo bisogno di un pezzo personalizzato per un prototipo e in pochi giorni ho avuto una soluzione precisa, pulita e pronta da testare.",
    a: "Cliente artigianale / maker",
  },
  {
    q: "Finalmente un servizio che risponde in modo chiaro, propone alternative e consegna senza far perdere tempo.",
    a: "Cliente business / piccola impresa",
  },
];

export const FAQS = [
  { q: "Quali file accettate?", a: "Accetto principalmente file STL. Se hai un formato diverso, possiamo valutare insieme la conversione o la fattibilità." },
  { q: "Posso ordinare anche un solo pezzo?", a: "Sì, puoi richiedere anche un singolo prototipo o un pezzo unico personalizzato." },
  { q: "Quanto tempo serve per la stampa?", a: "Dipende dalla dimensione, dal dettaglio e dal numero di pezzi. Dopo aver visto il file, ti do una stima chiara dei tempi." },
  { q: "Potete aiutarmi se il file non è perfetto?", a: "Sì, verifico il progetto e ti dico se serve qualche correzione prima della stampa." },
  { q: "Fate anche piccoli lotti?", a: "Certo. Il servizio è adatto sia a pezzi singoli sia a piccole produzioni per test, eventi o vendita." },
];

export const CONTACT = {
  whatsapp: "https://wa.me/393714227933",
  phone: "tel:+393714227933",
  phoneText: "371 422 7933",
  email: "mailto:cerraalessandro9@gmail.com",
  emailText: "cerraalessandro9@gmail.com",
};
